module.exports = __webpack_public_path__ + "static/media/Bano.3cf921e2.jpg";